/* eslint-disable no-unused-vars */
import { useRef } from 'react';
import { SearchAppPanel } from '../searchAppPanel/SearchAppPanel';
import { Loader, Buttons } from 'components';
import * as S from './ReportsTable.styled';
import { TableHeader } from './tableHeader/TableHeader';
import { StatisticRow } from './tableStatisticRow/StatisticRow';
import { TableBody } from './tableBody/TableBody';
import { useFacade } from './useFacade';
import { SelectedFilterItems } from './selectedFilterItems/SelectedFilterItems';

const TABLE_ROW_HEIGHT = 72;
const HEADER_ROW_HEIGHT = 64;
const STATISTIC_ROW_HEIGHT = 48;

const STORAGE_KEY = '___locache___/reports';

const formatCurrencyMetric = (value, fractionDigits) => {
  if (!value) return 0;

  return `$${Number(value).toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
};

const countStatistic = (tableData) => {
  const resAcc = {
    impressions: 0,
    clicks: 0,
    installs: 0,
    ctr: 0,
    earning: 0,
    rawEarning: 0,
    ecpm: 0,
  };
  const currentResult =
    tableData?.reduce((acc, row) => {
      acc.installs += row.installs;
      acc.clicks += row.clicks;
      acc.earning += row.earning;
      acc.rawEarning += row.rawEarning ?? row.earning;
      acc.impressions += row.impressions;
      return acc;
    }, resAcc) ?? resAcc;
  currentResult.ctr = currentResult.impressions
    ? `${((currentResult.clicks / currentResult.impressions) * 100).toFixed(2)}%`
    : 0;
  currentResult.ecpm = currentResult.impressions
    ? formatCurrencyMetric((currentResult.rawEarning / currentResult.impressions) * 1000, 3)
    : 0;

  currentResult.earning = formatCurrencyMetric(currentResult.earning, 2);

  return currentResult;
};

export const ReportsTable = ({
  appNumberIsSelected,
  toggleSelectedAppNumber,
  selectedAppsNumbers$,
  currentRequestType$,
}) => {
  const searchPanelRef = useRef(null);
  const {
    isLoading,
    isFetching,
    originalTableData$,
    isError,
    sortConfig$,
    sortedFilteredData$,
    visibleRows,
    numOfRows,
    handleLoadMore,
    placementList$,
    countryList$,
    advertiserList$,
    applicationsMap$,
    handleExport,
    hideAdvertiserGrouping,
    hideInstallsColumn,
    renderCols,
    isSamsungUser,
  } = useFacade({
    selectedAppsNumbers$,
    currentRequestType$,
  });

  if (isError) {
    return null;
    // return (
    //   <h2 style={{ border: '1px solid red', color: 'red', textAlign: 'center', padding: '10px 0' }}>
    //     ReportsTable Error
    //   </h2>
    // );
  }

  return (
    <S.Container>
      <S.SearchBox ref={searchPanelRef}>
        <SearchAppPanel
          appNumberIsSelected={appNumberIsSelected}
          toggleSelectedAppNumber={toggleSelectedAppNumber}
          currentRequestType$={currentRequestType$}
          placementList$={placementList$}
          countryList$={countryList$}
          advertiserList$={advertiserList$}
          handleExport={handleExport}
        />
      </S.SearchBox>
      <SelectedFilterItems
        placementList$={placementList$}
        countryList$={countryList$}
        advertiserList$={advertiserList$}
        selectedAppsNumbers$={selectedAppsNumbers$}
        applicationsMap$={applicationsMap$}
        toggleSelectedAppNumber={toggleSelectedAppNumber}
      />
      {isLoading || !originalTableData$.value ? (
        <S.LoaderBox>
          <Loader.Local delay={0} />
        </S.LoaderBox>
      ) : (
        <S.TableBox>
          <S.MyTable>
            <S.TableHead>
              <TableHeader
                currentRequestType$={currentRequestType$}
                isSamsungUser={isSamsungUser}
                originalTableData$={originalTableData$}
                HEADER_ROW_HEIGHT={HEADER_ROW_HEIGHT}
                STORAGE_KEY={STORAGE_KEY}
                sortConfig$={sortConfig$}
                hideAdvertiserGrouping={hideAdvertiserGrouping}
                renderCols={renderCols}
              />
              {sortedFilteredData$.value.length ? (
                <StatisticRow
                  STATISTIC_ROW_HEIGHT={STATISTIC_ROW_HEIGHT}
                  allStatistic={countStatistic(sortedFilteredData$.value)}
                  renderCols={renderCols}
                />
              ) : null}
            </S.TableHead>
            <TableBody
              currentRequestType$={currentRequestType$}
              visibleRows={visibleRows}
              data={sortedFilteredData$.value}
              TABLE_ROW_HEIGHT={TABLE_ROW_HEIGHT}
              isFetching={isFetching}
              hideInstallsColumn={hideInstallsColumn}
            />
          </S.MyTable>
          {!isFetching && !!numOfRows && (
            <S.TableFooter>
              <>
                <Buttons.TertiaryNormal
                  isDisabled={numOfRows === visibleRows}
                  onClick={handleLoadMore}
                  style={{ marginRight: '6px' }}
                >
                  Load More
                </Buttons.TertiaryNormal>
                <S.FooterBody>
                  <p>
                    Showed: <span>{visibleRows}</span> of <span>{numOfRows}</span>
                  </p>
                  <S.ProgressBar status={(visibleRows / numOfRows) * 100}></S.ProgressBar>
                </S.FooterBody>
              </>
            </S.TableFooter>
          )}
        </S.TableBox>
      )}
    </S.Container>
  );
};
